import React from 'react';
import useSWR from 'swr'
import fetcher from '../../utils/fetcher';
import Card from '../Card';
import moment from 'moment';
import 'moment/locale/ko';
import './style.css';

const PressReleaseLists = () => {
  const url = 'https://api.testworks.co.kr'
  const { data: pressReleaseDatas } = useSWR('https://api.testworks.co.kr/press-releases?_sort=id:DESC', fetcher);

  return (
    <section className='press-releaselist'>
      <div className='list-container'>
        {pressReleaseDatas && (
          pressReleaseDatas.map((data) => {
              if (data.showhome) {
                  return (
                      <Card
                          key={data.id}
                          id={data.id}
                          to={`/pressdetail/${data.id}`}
                          src={url + data.thumbnail.url}
                          title={data.title}
                          preview={data.preview}
                          date={moment(data.set_day).format('YYYY.MM.DD')}
                      />
                  )} else {
                  return null;
              }
          })
        )}
      </div>
    </section>
  )
}
export default PressReleaseLists;
